import { render, staticRenderFns } from "./Each_Bact_Show.vue?vue&type=template&id=841d0f3e&scoped=true"
import script from "./Each_Bact_Show.vue?vue&type=script&lang=js"
export * from "./Each_Bact_Show.vue?vue&type=script&lang=js"
import style0 from "./Each_Bact_Show.vue?vue&type=style&index=0&id=841d0f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841d0f3e",
  null
  
)

export default component.exports